import React from 'react';

function NotFound(props) {
  return (
    <>
      404 NotFound Error.
      <p>
        잘못된 경로입니다.
      </p>
    </>
  );
}

export default NotFound;